export default __webpack_public_path__ + "static/media/ai_image.a5ee8f1f.jpg";